import { useIntl } from "react-intl";
import { SORT_OPTIONS, type SortKey } from "@/lib/share-sort";

// Sort dropdown for the Share feeds (Discover + Meine Beiträge). The
// sort-key -> `order` mapping lives in lib/share-sort so callers spread
// sortOrderFor(key) into their query.

export function ShareSortSelect({
  value,
  onChange,
  options = SORT_OPTIONS,
}: {
  value: SortKey;
  onChange: (next: SortKey) => void;
  options?: ReadonlyArray<(typeof SORT_OPTIONS)[number]>;
}) {
  const intl = useIntl();
  return (
    <label className="inline-flex items-center gap-2">
      <span className="text-smycles-micro tracking-[0.2em] text-ink-muted">{intl.formatMessage({ id: "sort.label", defaultMessage: "Sort" })}</span>
      <span className="relative inline-block">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value as SortKey)}
          className="appearance-none rounded-full bg-ink/[0.06] py-2 pl-4 pr-9 text-smycles-label tracking-[0.15em] text-ink transition hover:text-ink focus:outline-none focus:ring-1 focus:ring-ink-ui"
        >
          {options.map((o) => (
            <option key={o.id} value={o.id}>
              {intl.formatMessage({ id: o.labelId })}
            </option>
          ))}
        </select>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="pointer-events-none absolute right-3 top-1/2 h-3 w-3 -translate-y-1/2 text-ink-muted"
        >
          <path d="m6 9 6 6 6-6" />
        </svg>
      </span>
    </label>
  );
}
